import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { DashboardResult } from '../components/dashboard/dashboard';
import { Insights } from '../components/insights/insights';

import Header from '../../../components/header/header';

import { getSummary } from '../actions/dashboard';

class Dashboard extends Component {
  componentDidMount() {
    const {
      getSummary,
    } = this.props;

    getSummary({ year: new Date().getFullYear() });
  }

  render() {
    const {
      userLogged,
    } = this.props;

    return (
      <>
        <Header userLogged={userLogged} />
        <DashboardResult />

        <Insights />
      </>
    )
  }
}

const mapStateToProps = ({ authReducer: { authenticated } }) => ({
  userLogged: authenticated,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    getSummary,
  }, dispath)
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
